import React, { useState } from "react";

import { TextField } from "@material-ui/core";
import { theme } from "../../theme";
import { Wrapper, Error } from "./styles";
import { FormattingDateChange, formatToRupees } from "../../utils/utils";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  root: {
    width: "100%",
    fontSize: "13px !important",
    color: "#099"
  },
});

const BaseInput = ({ label, disabled, variant, formikProps, type, date }) => {
  const { values, handleChange, name, errors, touched } = formikProps;
  const classes = useStyles();
  const [ formatValue, setFormatValue] = useState(values[name]);
  const handleChangeAmount = (e) => {
    if(date){
      // FormattingDateChange(e, formikProps)
      let newDate = e.target.value;
      let prevDateLen = values[name].length;
      let newDateLen = newDate.length;
      let newDob = newDate;

      if (newDateLen < prevDateLen) {
        newDob = values[name].substr(0, prevDateLen - 1);
      } else if (newDateLen <= 10) {
        if (newDateLen === 2 || newDateLen === 5) {
          newDob = newDate + "/";
        }
      } else {
        newDob = newDate.slice(0, 10);
      }
      // regex to enable digit and / only
      const regex = /^[0-9\b/]+$/;
      if (newDob === "" || regex.test(newDob)) {
        handleChange && handleChange(e);
        setFormatValue(newDob);
      }
      values[name] = newDob
      } else {
      const regex = /^[A-Za-z]+$/;//for alphabets only
      if(e.target.value === "" || regex.test(e.target.value)){
        handleChange && handleChange(e);
        setFormatValue(e.target.value);
      }
      }
}
  return (
    <Wrapper>
      <TextField
        disabled={disabled}
        className={classes.root}
        label={label}
        variant={variant ? variant : "outlined"}
        value={formatValue}
        name={name}
        type={type || "text"}
        onChange={handleChangeAmount}
      />
      {errors && errors[name] && touched && touched[name] && (
        <Error>{errors[name]}</Error>
      )}
    </Wrapper>
  );
};

export default BaseInput;
